
import { Options, Vue } from 'vue-class-component';
import PasswordResetRequestForm from "@/components/PasswordResetRequestForm.vue";

@Options({
    props: {
        shown: {
            type: Boolean,
            required: true,
        }
    },
    components: {
        PasswordResetRequestForm,
    },
    emits: [
        'close',
    ]
})
export default class PasswordResetRequestModal extends Vue {
    shown!: boolean

    /*
    onLogin() {
        this.$emit('login');
        this.closeModal();
    }
    */

    closeModal() {
        this.$emit('close');
    }
}
